<template>
  <v-dialog v-model="visible" max-width="500">
    <v-card v-if="visible">
      <v-card-title> Change password </v-card-title>
      <v-card-text>
        <v-form ref="editForm" lazy-validation>
          <v-text-field
            v-model="oldPassword"
            label="Old password"
            v-bind:append-icon="showOldPassword ? 'mdi-eye' : 'mdi-eye-off'"
            v-bind:type="showOldPassword ? 'text' : 'password'"
            v-bind:rules="[rules.required, rules.password]"
            v-on:click:append="showOldPassword = !showOldPassword"
            autofocus
            outlined
            dense
          />

          <v-text-field
            v-model="newPassword"
            label="New password"
            v-bind:append-icon="showNewPassword ? 'mdi-eye' : 'mdi-eye-off'"
            v-bind:counter="16"
            v-bind:type="showNewPassword ? 'text' : 'password'"
            v-bind:rules="[rules.required, rules.password]"
            v-on:click:append="showNewPassword = !showNewPassword"
            outlined
            dense
          />

          <v-text-field
            v-model="confirmPassword"
            label="Confirm password"
            v-bind:append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
            v-bind:counter="16"
            v-bind:type="showConfirmPassword ? 'text' : 'password'"
            v-bind:rules="[confirmEquals]"
            v-on:click:append="showConfirmPassword = !showConfirmPassword"
            outlined
            dense
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn v-on:click="save" text> Save </v-btn>
        <v-btn v-on:click="visible = false" text> Cancel </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "UserChangePassword",

  props: {
    value: { type: Boolean, default: false }
  },

  data: () => ({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
    showOldPassword: false,
    showNewPassword: false,
    showConfirmPassword: false,
    rules: {
      required: value => !!value || "Mandatory field",
      password: value =>
        !value ||
        /^((?!.*[\s])(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&_\-*]).{8,16})$/.test(
          value
        ) ||
        "Password must be 8 to 16 characters length and  have at least un uppercase character, a lower case charcter, a digit and a special charcter like: -!@#$%^&_*"
    }
  }),

  computed: {
    visible: {
      get() {
        return !!this.value;
      },
      set(visible) {
        visible === false && this.$emit("input", null);
      }
    },

    confirmEquals() {
      return value =>
        value === this.newPassword || "Confirm password does not match";
    }
  },

  watch: {
    visible(visible) {
      if (visible) {
        this.oldPassword = this.newPassword = this.confirmPassword = "";
        this.showOldPassword = false;
        this.showNewPassword = false;
        this.showConfirmPassword = false;
        this.$refs.editForm && this.$refs.editForm.resetValidation();
      }
    }
  },

  methods: {
    // Save password
    save() {
      this.$refs.editForm.validate() &&
        this.$emit("save", {
          oldPassword: this.oldPassword,
          newPassword: this.newPassword
        });
    }
  }
};
</script>
